import { Divider, Grid, Menu, MenuItem } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonDelete from "components/Buttons/ButtonDelete";
import ButtonEdit from "components/Buttons/ButtonEdit";
import ButtonEllipsis from "components/Buttons/ButtonEllipsis";
import ButtonPublish from "components/Buttons/ButtonPublish";
import ButtonViewComment from "components/Buttons/ButtonViewComment";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { ApprovalStatus } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import PublicationLogDialog from "views/Publication/Dialogs/PublicationLogDialog";
import WorkFlowMessageDrawer from "views/Timeline/Dialogs/WorkFlowMessageDrawer";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    menuAnchorEl: HTMLElement;
    dialog: any;
}

interface IProps {
    data: FeedItemDto;
    onRemovePublication?: () => void;
    onEditPublication?: () => void;
    onPublishPublication?: () => void;
    removeInDropDown?: boolean;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ActionsPublisher extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
            dialog: null
        };
    }

    ///
    private handleOpenMenu(e: React.MouseEvent<HTMLElement>) {
        this.setState({ menuAnchorEl: e.currentTarget });
    }

    ///
    private handleCloseMenu() {
        this.setState({ menuAnchorEl: null });
    }

    ///
    private handleCloseDialog() {
        this.setState({ dialog: null });
    }

    ///
    private handleAudit = () => {
        this.setState({
            menuAnchorEl: null,
            dialog: <PublicationLogDialog
                publicationId={this.props.data.publicationId}
                onClose={() => this.handleCloseDialog()}
            />
        });
    };

    ///
    private getActionMenu() {
        const { t } = this.props;
        const actionMenu: Array<any> = [];

        actionMenu.push(<MenuItem key="audit" onClick={this.handleAudit}>{t("Common.MenuAction.Audit")}</MenuItem>);

        if (this.props.onRemovePublication && this.props.removeInDropDown) {
            if (actionMenu.length > 0) actionMenu.push(<Divider key="dividerDelete" />);
            actionMenu.push(<MenuItem key="delete" onClick={() => this.props.onRemovePublication()}><MuiColor variant="error">{t("Common.MenuAction.Delete")}</MuiColor></MenuItem>);
        }

        return actionMenu.length == 0 ? null : actionMenu;
    }

    ///
    public render() {
        const { menuAnchorEl } = this.state;
        const { t, data: { publication: { approvalStatus, lastWorkflowStep } } } = this.props;

        const actionMenu = this.getActionMenu();

        return (
            <>
                {this.state.dialog}

                <Grid container justifyContent="space-between" >
                    <Grid item>
                        {
                            this.props.onEditPublication &&
                            <ButtonEdit
                                onClick={() => { this.props.onEditPublication(); }}
                            />
                        }

                    </Grid>

                    <Grid item>
                        {
                            this.props.onPublishPublication &&
                            <ButtonPublish
                                onClick={() => { this.props.onPublishPublication(); }}
                            />
                        }
                    </Grid>

                    <Grid item>
                        {
                            this.props.onPublishPublication && approvalStatus === ApprovalStatus.Rejected && lastWorkflowStep.comment &&
                            <ButtonViewComment
                                onClick={
                                    () => {
                                        this.setState({
                                            dialog: <WorkFlowMessageDrawer
                                                title={t("Common.Feed.Actions.ApprovalResultTitle")}
                                                onClose={this.handleCloseDialog}
                                                workflowStep={lastWorkflowStep}
                                            />
                                        });
                                    }}
                            />
                        }
                    </Grid>

                    <Grid item>
                        {
                            this.props.onRemovePublication && !this.props.removeInDropDown &&
                            <ButtonDelete
                                color="transparent"
                                onClick={() => { this.props.onRemovePublication(); }}
                            />
                        }
                    </Grid>

                    {
                        actionMenu &&
                        <Grid item>
                            <ButtonEllipsis
                                onClick={(e) => { this.handleOpenMenu(e); }}
                            />
                            <Menu
                                anchorEl={menuAnchorEl}
                                open={menuAnchorEl != null}
                                onClose={() => { this.handleCloseMenu(); }}
                            >
                                {actionMenu}
                            </Menu>
                        </Grid>
                    }

                </Grid>
            </>
        );
    }
}

export default withSnackbar(withTranslation()(ActionsPublisher));